import {Component, Inject, OnInit} from '@angular/core';
import {CsvSubscription} from '../../../shared/classes/csv-subscription/csv-subscription';
import {FormControl, FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ProjectSubscriptionService} from '../../../shared/services/project-subscription/project-subscription.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../shared/services/state/states.service';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {NewsteoSubscription} from '../../../shared/classes/newsteo-subscription/newsteo-subscription';

@Component({
  selector: 'app-newsteo-subscription',
  templateUrl: './newsteo-subscription.component.html',
  styleUrls: ['./newsteo-subscription.component.css']
})
export class NewsteoSubscriptionComponent implements OnInit {

  public faTimes = faTimes;
  public projectId: number;
  public newsteoSubscriptionId: number;
  public showSpinner: boolean;
  public newsteoSubscription: NewsteoSubscription;
  public newsteoSubscriptionForm: FormGroup;
  public projectName: string;

  constructor(private toastr: ToastrService,
              private projectSubscriptionService: ProjectSubscriptionService,
              private translate: TranslateService,
              public statesService: StatesService,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.projectId = data.project.id;
    this.projectName = data.project.name;
    this.newsteoSubscriptionId = data.newsteoSubscriptionId;
    this.newsteoSubscriptionForm = new FormGroup({
        newsteoProjectId: new FormControl('')
      }
    );

  }

  ngOnInit() {
    if (this.newsteoSubscriptionId !== null) {
      this.showSpinner = true;
      this.projectSubscriptionService.getNewsteoSubscription(this.newsteoSubscriptionId).subscribe(
        (newsteoSubscription: NewsteoSubscription) => {
          this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          this.newsteoSubscription = newsteoSubscription;
          this.newsteoSubscriptionForm.patchValue({
            newsteoProjectId: this.newsteoSubscription.newsteoProjectId !== undefined ? this.newsteoSubscription.newsteoProjectId : '',
          });
          this.showSpinner = false;
        }, error => {
          this.showSpinner = false;
        });
    }
  }

  postNewsteoSubscription() {
    if (this.newsteoSubscriptionForm.valid) {
      let newsteoSubscription = this.buildNewsteoSubscription();

      if (JSON.stringify(newsteoSubscription) === JSON.stringify(this.newsteoSubscription)) {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      } else {
        this.showSpinner = true;
        this.newsteoSubscription = newsteoSubscription;
        this.projectSubscriptionService.postNewsteoSubscription(this.newsteoSubscription).subscribe(
          d => {
            this.statesService.reloadListProject.next();
            this.toastr.success(this.translate.instant('SUBSCRIPTION_CREATED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          },
          error => {
            this.showSpinner = false;
          });
      }
    }
  }

  private buildNewsteoSubscription() {
    let newsteoSubscription = new NewsteoSubscription();
    newsteoSubscription.osmosProjectId = this.projectId;
    newsteoSubscription.newsteoProjectId = this.newsteoSubscriptionForm.value.newsteoProjectId;
    return newsteoSubscription;

  }


}
